<article
  class="update-card"
  [class.is-disabled]="data?.disabled"
  [class.layout-compact]="layoutDensity === 'compact'"
  [class.layout-dense]="layoutDensity === 'dense'"
  [ngStyle]="cardStyles"
  [style.height]="resolvedHeight"
  role="link"
  [attr.aria-label]="data?.ariaLabel || data?.title"
  [attr.tabindex]="data?.disabled ? -1 : 0"
  (click)="navigate()"
  (keydown)="onCardKeydown($event)">
  <div class="card-header">
    <div class="main-icon" aria-hidden="true">
      <img *ngIf="isImageIcon(data?.iconUrl); else mainSvg" [src]="data.iconUrl" alt="" />
      <ng-template #mainSvg>
        <svg viewBox="0 0 24 24">
          <ng-container [ngSwitch]="data?.icon || 'document'">
            <path *ngSwitchCase="'tag'" d="M20.6 13.6 13.7 20.5a2 2 0 0 1-2.8 0L3.5 13.1V4h9.1l8 8a2 2 0 0 1 0 1.6ZM8 8h.01" />
            <path *ngSwitchCase="'chart'" d="M4 20V10m6 10V4m6 16v-7m4 7H2" />
            <path *ngSwitchDefault d="M14 2H6a2 2 0 0 0-2 2v16h16V8l-6-6Zm0 0v6h6M8 13h8M8 17h8" />
          </ng-container>
        </svg>
      </ng-template>
    </div>

    <div class="card-copy">
      <h3>{{ data?.title }}</h3>
      <p>{{ data?.description }}</p>
    </div>

    <div class="header-actions" *ngIf="actions.length">
      <button
        *ngFor="let action of actions"
        type="button"
        [attr.aria-label]="action.label || action.icon"
        [attr.title]="action.label || action.icon"
        [style.color]="action.color"
        [style.background-color]="action.backgroundColor"
        (click)="onActionClick($event, action)">
        <img *ngIf="isImageIcon(action.iconUrl); else actionSvg" [src]="action.iconUrl" alt="" />
        <ng-template #actionSvg>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path *ngIf="action.icon === 'delete'" d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" />
            <path *ngIf="action.icon !== 'delete'" d="m4 20 4.2-1 10.9-10.9a2.1 2.1 0 0 0-3-3L5.2 16 4 20Zm10.5-13.5 3 3M13 20h7" />
          </svg>
        </ng-template>
      </button>
    </div>
  </div>

  <div class="divider"></div>

  <div class="card-footer">
    <div class="metadata">
      <div *ngIf="data?.createdLabel || data?.createdDate">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3v3m10-3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z" /></svg>
        <span><strong>{{ data?.createdLabel || 'Created:' }}</strong> {{ data?.createdDate }}</span>
      </div>
      <div *ngIf="data?.lastUsedLabel || data?.lastUsedDate">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-13v5l3 2" /></svg>
        <span><strong>{{ data?.lastUsedLabel || 'Last used:' }}</strong> {{ data?.lastUsedDate }}</span>
      </div>
    </div>

    <button class="go-button" type="button" [attr.aria-label]="data?.buttonLabel || 'Open'" (click)="onActionClick($event, data)">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 10 7L9 19V5Z" /></svg>
    </button>
  </div>
</article>
